import React from "react";

import "../../scss/molecules/_toggleable-section.scss";

class ToggleableSection extends React.Component {
  state = {
    active: this.props.active || false,
  };
  toggle() {
    this.setState({ active: !this.state.active });
    history.replaceState(null, null, "#" + this.props.hashTitle);
  }
  render() {
    return (
      <div
        className={"toggleable-section" + (this.state.active ? " active" : "")}
      >
        <div
          className="toggleable-section-toggle"
          onClick={() => {
            this.toggle();
          }}
        >
          {this.props.toggle}
        </div>
        <div className="toggleable-section-body">{this.props.children}</div>
      </div>
    );
  }
}

export default ToggleableSection;
